exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/session-timeout-modal/session-timeout-modal.component.scss
// module id = ../../../../../src/app/shared/components/session-timeout-modal/session-timeout-modal.component.scss
// module chunks = main